import { createAction, props } from '@ngrx/store';
export const setSavedItems = createAction('[Saved Items] Set Items', props());
export const createSavedItem = createAction('[Saved Items] Create Item', props());
export const deleteSavedItem = createAction('[Saved Items] Delete Item', props());
export const updateSavedItem = createAction('[Saved Items] Update Item', props());
